import React from 'react';
import {PropTypes} from 'prop-types';
import {CreateInputValueHandler} from  './inputValueHandler';

class BaseFormComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        
        let formData = {...props.formData};
        this.state = {formData: formData, _formData: {...formData}};

        this.setFormData = this.setFormData.bind(this);
        this.isChanged = this.isChanged.bind(this);
        this.getControlClass = this.getControlClass.bind(this);
        this.getInputValueOptions = this.getInputValueOptions.bind(this);
        this.getInputValueFromEvent = this.getInputValueFromEvent.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.onInputValueChanged = this.onInputValueChanged.bind(this);
        this._valueHandler = CreateInputValueHandler(this.onInputValueChanged);
    }

    setFormData(data) {
        const self = this;
        const newFormData = {...self.state.formData, ...data};
        self.setState({formData: {...newFormData}});
    }

    isChanged() {
        const result = JSON.stringify(this.state.formData) !== JSON.stringify(this.state._formData);

        return result;
    }

    onInputValueChanged(name, value, event, options) {
        const self = this;

        if (typeof self.props.onChange === 'function') {
            self.props.onChange(name, value, event, options);
        }
        else {
            let needUpdate = false;

            const formData = {...self.state.formData};
            const names = name.split('.');

            let obj = formData;

            names.forEach((propName, i) => {
                if (i == names.length - 1) { // last 
                    if ((obj[propName] != value) || (event.target.value != value)) {
                        obj[propName] = value;
                        needUpdate = true;
                    }
                }
                else {
                    const propValue = {...obj[propName]};
                    obj[propName] = propValue;
                    obj = propValue;
                }
            })

            if (needUpdate) {
                self.setState({formData: formData});
            }

            // if ((formData[name] != value) || (target.value != value)) {
            //     formData[name] = value;
            //     self.setState({formData: formData});
            // }
        }
    }

    getInputValueOptions(event, options) {
        const result = this._valueHandler.getInputValueOptions(event, options);

        return result;
    }

    getInputValueFromEvent(event, options) {
        const result = this._valueHandler.getInputValueFromEvent(event, options);

        return result;
    }

    handleInputChange(event, options) {
        const result = this._valueHandler.handleInputChange(event, options);

        return result;
    }

    getControlClass(errorName, errors, className) {
        const result = this._valueHandler.getControlClass(errorName, errors, className);

        return result;
    }

    getControlError(errorName, errors) {
        const result = this._valueHandler.getControlError(errorName, errors);

        return result;
    }
}
BaseFormComponent.propTypes = {
    onChange: PropTypes.func,
    formData: PropTypes.object
}
BaseFormComponent.defaultProps = {
    onChange: null,
    formData: null
}
BaseFormComponent.OPTIONS = {
    AllTrim: {
        doLTrim: true, 
        doRTrim: true
    }
}
BaseFormComponent.EmailOptions = { ...BaseFormComponent.OPTIONS.AllTrim },
BaseFormComponent.PasswordOptions = { ...BaseFormComponent.OPTIONS.AllTrim };


export {BaseFormComponent};